import ngeohash from 'ngeohash';

/**
 * This utility library has also been copied to orderweb; If you make changes
 * here please ensure you duplicate those changes in orderweb too.
 */

export function getCoordinates(geometry) {
  const { location } = geometry;
  return [location.lat(), location.lng()];
}

export function getGeohash(geometry) {
  const { location } = geometry;
  return ngeohash.encode(location.lat(), location.lng());
}

export function getLocality(addressComponents) {
  const { long_name: locality } =
    addressComponents.find((component) => component.types.includes('locality')) || {};

  return locality || undefined;
}

export function getPostcode(addressComponents) {
  const { long_name: postcode } =
    addressComponents.find((component) => component.types.includes('postal_code')) || {};

  return postcode || undefined;
}

/**
 * Correctly format a postcode where all spaces had previously been stripped
 * out.
 */
export function formatUKPostcode(postcode) {
  if (!postcode) {
    return postcode;
  }

  const postcodeMatches = postcode.match(/^([A-Z][A-Z]?[0-9][0-9]?[A-Z]?)([0-9][A-Z][A-Z])$/);
  if (postcodeMatches) {
    const [_, first, second] = postcodeMatches; // eslint-disable-line no-unused-vars
    return `${first} ${second}`;
  }

  // fallback to returning the postcode unchanged
  return postcode;
}

/**
 * Used to determine if a place returned by Google’s geocoding API is accurate
 * enough to use for a Restaurants API search.
 */
export function isPlaceAccurate({ place }) {
  const { geometry, types } = place;
  const accuratePlaceTypes = [
    'street_address',
    'street_number',
    'premise',
    'subpremise',
    'point_of_interest',
    'establishment',
  ];

  switch (geometry.location_type) {
    case 'ROOFTOP':
    case 'GEOMETRIC_CENTER':
    case 'RANGE_INTERPOLATED': {
      return types && types.some((type) => accuratePlaceTypes.includes(type));
    }
    default:
      return false;
  }
}

/**
 * Return a standard set of address fields used by location actions.
 */
export function getAddressFields({ place }) {
  const {
    formatted_address: formattedAddress,
    geometry: { location },
    address_components: addressComponents,
    place_id: placeId,
  } = place;

  const isLocationAccurate = isPlaceAccurate({ place });
  const postalCode = getPostcode(addressComponents);

  return {
    formattedAddress,
    placeId,
    coords: {
      lat: location.lat(),
      lng: location.lng(),
    },
    postalCode,
    isLocationAccurate,
  };
}
